// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__TRZ0J","fullWidthInput":"AuthForm_fullWidthInput__8bZlM","submitButton":"AuthForm_submitButton__x2kEu"};